import { Injectable } from '@angular/core';
import { AuthService } from '@pg-app/core/services/auth.service';
import { Keepalive } from '@ng-idle/keepalive';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class KeepAliveService {
    private isSetUp = false;

    constructor(
        private keepalive: Keepalive,
        private authenticationService: AuthService,
        private toastr: ToastrService,
    ) {
    }

    isServiceRunning() {
        return this.keepalive.isRunning();
    }

    startService() {
        if (!this.keepalive.isRunning()) {
            this.keepalive.start();
        }
    }

    stopService() {
        this.keepalive.stop();
    }

    start(timeFreshtokenSec: number = 900) {
        if (!this.isSetUp) {
            this.keepalive.interval(timeFreshtokenSec);

            this.keepalive.onPing.subscribe(() => {
                this.authenticationService.refreshAccessToken().subscribe(
                    res => {
                        if (res && res.isSucceeded) {
                            this.authenticationService.updateAccessToken(res.token);
                        } else {
                            this.toastr.error(res.error)
                            this.authenticationService.logout(true);
                        }
                    }
                );
            });
            this.isSetUp = true;
        }
    }
}
